import { render, staticRenderFns } from "./round.vue?vue&type=template&id=742b902b&scoped=true"
import script from "./round.vue?vue&type=script&lang=js"
export * from "./round.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742b902b",
  null
  
)

export default component.exports